import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import { ticketEmbeddedVarsSelector } from '@/redux/app/selectors/ticket';

export interface EmbeddedVarsSelectorProps {
  ticket: string;
}

export const EmbeddedVarsSelector = ({ ticket }: EmbeddedVarsSelectorProps) => {
  const embeddedVars = useSelector(_.partial(ticketEmbeddedVarsSelector, ticket));
  return (
    <div className="navigator variables active">
      {embeddedVars instanceof Array && embeddedVars
        .filter(({ personalize }) => !!personalize)
        .map(({ custom_var, var_name, personalize }) => (
          <a
            tabIndex={0}
            key={var_name}
            data-var={custom_var}
            data-var-name={var_name}
            data-personalize={personalize}
          >
            {var_name}
            <span className="small-text">{personalize}</span>
          </a>
        ))}
    </div>
  );
};
